import { TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";

const HtHd = ({ sortInfo, createSortHandler }) => {
	const sortLabel = (key, name) => (
		<TableSortLabel
			active={sortInfo.sort === key}
			direction={sortInfo.sort === key ? sortInfo.sort_by : 'asc'}
			onClick={() => createSortHandler(key)}
		>
			{name}
		</TableSortLabel>
	);

	return (
		<TableHead className="engine-module-table">
			<TableRow>
				<TableCell colSpan={11} />
				<TableCell colSpan={3} align="center">Dimension</TableCell>
				<TableCell colSpan={3} align="center">Next Due</TableCell>
				<TableCell colSpan={3} align="center">Life Remaining</TableCell>
				<TableCell colSpan={2} />
			</TableRow>
			<TableRow>
				<TableCell style={{ minWidth: '140px' }}>Action(s)</TableCell>
				<TableCell style={{ minWidth: '130px' }}>{sortLabel('ata_chapter', 'ATA Chapter')}</TableCell>
				<TableCell style={{ minWidth: '200px' }}>{sortLabel('part_description', 'Part Description')}</TableCell>
				<TableCell style={{ minWidth: '120px' }}>{sortLabel('part_number', 'Part Number')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('part_serial_number', 'Part Serial Number')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('part_installation_date', 'Part Installation Date')}</TableCell>
				<TableCell style={{ minWidth: '180px' }}>{sortLabel('aircraft_tsn_installation', 'Aircraft TSN Installation')}</TableCell>
				<TableCell style={{ minWidth: '180px' }}>{sortLabel('aircraft_csn_installation', 'Aircraft CSN Installation')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('part_tsn_installation', 'Part TSN Installation')}</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('part_csn_installation', 'Part CSN Installation')}</TableCell>
				<TableCell style={{ minWidth: '140px' }}>{sortLabel('ht_requirement', 'HT Requirement')}</TableCell>
				<TableCell>Days</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell>Date</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell>Days</TableCell>
				<TableCell>FH</TableCell>
				<TableCell>FC</TableCell>
				<TableCell style={{ minWidth: '160px' }}>{sortLabel('remark', 'Remarks')}</TableCell>
				<TableCell>Attachments</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default HtHd;
